import ViewDashboardContainer from './container';

const ViewDashboard = ViewDashboardContainer;

export default ViewDashboard;
